import { useTranslation } from 'react-i18next';
import React from 'react';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import fr from 'javascript-time-ago/locale/fr.json';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(fr);

export default function useTimeAgo(date: number, mixedStyled?: boolean) {
  const { i18n } = useTranslation();
  const timeAgo = new TimeAgo(i18n.language);
  const init: [string, number?] = timeAgo.format(date, { rounding: 'round', getTimeToNextUpdate: true }) as unknown as [string, number?];
  const [dateAgo, setDateAgo] = React.useState<[string, number?]>(init);
  const isStale = Date.now() - date > 1000 * 60 * 60 * 24 * 7;
  const dateFormat = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium' });

  React.useEffect(() => {
    const intervalTimeout = (Date.now() - date < 60000) ? 1000 : dateAgo[1];
    const interval = setInterval(() => {
      const update: [string, number?] = timeAgo.format(date, 'round', { getTimeToNextUpdate: true }) as unknown as [string, number?];
      setDateAgo(update);
    }, intervalTimeout);
    return () => clearInterval(interval);
  }, [dateAgo[1], date]);

  React.useEffect(() => {
    const update: [string, number?] = timeAgo.format(date, 'round', { getTimeToNextUpdate: true }) as unknown as [string, number?];
    setDateAgo(update);
  }, [date, i18n.language]);

  if (isStale && mixedStyled) { return dateFormat.format(date); }

  return dateAgo[0];
}
